export default function sumObjectValues<ReturnType>(objectArr: Record<string, unknown>[], key: string, fallback: ReturnType): ReturnType {
  if (!objectArr.length) return fallback;

  let returnValue: string | number | undefined;

  objectArr.forEach((object) => {
    const objectValue: unknown = object?.[key];

    if (!['string', 'number'].includes(typeof objectValue)) return;

    if (!returnValue) {
      if (typeof objectValue === 'string') returnValue = '';
      if (typeof objectValue === 'number') returnValue = 0;
    }

    if (typeof objectValue !== typeof returnValue) return;

    if (typeof object?.[key] === 'string') returnValue += object?.[key] as string;
    if (typeof object?.[key] === 'number') (returnValue as number) += object?.[key] as number;
  });

  return (returnValue || fallback) as ReturnType;
}
